import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

import { i18n } from '../../translate/i18n';

const InformationModal = ({ title, children, open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby='confirm-dialog'
    >
      <DialogTitle id='confirm-dialog'>{title}</DialogTitle>
      <DialogContent dividers>
        <Typography>{children}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          onClick={() => onClose(false)}
          color='default'
        >
          {i18n.t('Fechar')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InformationModal;
